<template>
  <div class="container text-center">
    <h3>Thank you for your registeration</h3>
    <h3>We will verification your registration as soon as possible</h3>
    <h3>Contact us if you have any problem</h3>
    <br>
    <h5>WeChat: colleen0901</h5>
    <h5>Line: colleen0901</h5>
    <h5>Whatapp: +886 967 149 658</h5>
  </div>
</template>

<script>

export default {
  name: 'RegisterThankyou'
}

</script>

<style lang="scss" scoped>
.container {
  margin: 50px;
}
</style>